var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { "data-grm-comp": "RoomCBTLogInfo" } }, [
    _c("table", [
      _vm._m(0),
      _vm._m(1),
      _c("tbody", [
        _c("tr", [
          _c("td", [_vm._v(_vm._s(_vm.cbtLog.cbt.questionCnt))]),
          _c("td", [_vm._v(_vm._s(_vm.getRoomCBTLogTotalScore()))]),
          _c("td", [_vm._v(_vm._s(_vm.cbtLog.roomCbtUserLogList.length))]),
          _c("td", [_vm._v(_vm._s(_vm.duration(_vm.cbtLog.duration)))]),
          _c("td", [
            _vm._v(
              _vm._s(
                _vm.dayjs(_vm.cbtLog.beginDate).format("YYYY-MM-DD HH:mm:ss")
              ) +
                " ~ " +
                _vm._s(
                  _vm.dayjs(_vm.cbtLog.endDate).format("YYYY-MM-DD HH:mm:ss")
                )
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("colgroup", [
      _c("col", { attrs: { width: "1" } }),
      _c("col", { attrs: { width: "1" } }),
      _c("col", { attrs: { width: "1" } }),
      _c("col", { attrs: { width: "1" } }),
      _c("col", { attrs: { width: "3" } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("문항 수")]),
        _c("th", [_vm._v("총 점수")]),
        _c("th", [_vm._v("참여 인원")]),
        _c("th", [_vm._v("제한 시간")]),
        _c("th", [_vm._v("출제 기간")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }